import { c as _c } from "react/compiler-runtime";
import { ProjectMarkupsTableHeaders } from "@pages/project-details/project-markups/project-markups-table-utils";
import { DropdownFilterChip } from "@components/common/faro-table/faro-table-filter/dropdown-filter-chip";
import { useProjectMarkupsFilterLists } from "@pages/project-details/project-markups/project-markups-filters/project-markups-filter-list";
import { TableType } from "@utils/track-event/track-event-list";

/** Show filters and apply them for project markup due date */
export function ProjectMarkupsDueDateFilter() {
  const $ = _c(4);
  const allFilters = useProjectMarkupsFilterLists();
  let t0;
  if ($[0] !== allFilters) {
    t0 = allFilters["Due Date"] ?? {};
    $[0] = allFilters;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <DropdownFilterChip label={ProjectMarkupsTableHeaders.dueDate} filteredColumn={ProjectMarkupsTableHeaders.dueDate} items={t0} shouldShowCheckbox={false} shouldShowSearchBox={false} shouldShowCheckIconOnRight={true} shouldAllowLabelTranslation={true} tableType={TableType.projectMarkups} />;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}